import styled from 'styled-components';

export const SwitchWrapper = styled.div`
  .ant-switch-checked {
    background-color: ${({ theme }) => theme.primary};
  }
`;

export const ConnectorWrapper = styled.div`
  display: flex;
  align-self: center;
  justify-self: end;
  background-color: #F3F4F6;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 16px;
`;

export const Label = styled.div`
  color: #7f7f7f;
  margin-bottom: 2px;
  font-weight: 300;
  font-size: 15px;
`;

export const MessageBox = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`;
